module.exports = __webpack_public_path__ + "img/2.dcf8f98a.png";